import type { ChatRepository } from '@src/domain/chat/repository/chat.repository';
import type { SendChatMessageDTO } from '../dto/chat.dto';

/**
 * Send Message Use Case
 * Handles sending a chat message following clean architecture principles
 */
export class SendMessageUseCase {
    constructor(private readonly chatRepository: ChatRepository) { }

    async execute(dto: SendChatMessageDTO): Promise<void> {
        // Validate input
        this.validateInput(dto);

        // Use phone number if available, otherwise use email
        const identifier = dto.phoneNumber || dto.email;

        // Send via repository
        await this.chatRepository.sendMessage(dto.query, identifier);
    }

    private validateInput(dto: SendChatMessageDTO): void {
        if (!dto.query || dto.query.trim().length === 0) {
            throw new Error('Query cannot be empty');
        }

        if (dto.query.length < 1 || dto.query.length > 1000) {
            throw new Error('Query must be between 1 and 1000 characters');
        }

        // Require either phone number or email
        if (!dto.phoneNumber && !dto.email) {
            throw new Error('Either phone number or email is required');
        }
    }
}
